var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 11C21.125 16.5919 16.5919 21.125 11 21.125C5.40812 21.125 0.875 16.5919 0.875 11C0.875 5.40812 5.40812 0.875 11 0.875C16.5919 0.875 21.125 5.40812 21.125 11Z",
    stroke: "#34657F",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 16.2383H13.4436",
    stroke: "#34657F",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.38086H11V15.7142",
    stroke: "#34657F",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.765 3.77148C10.0685 3.77148 9.50781 4.3372 9.50781 5.02863C9.50781 5.72508 10.0685 6.28577 10.765 6.28577C11.4564 6.28577 12.0221 5.72508 12.0221 5.02863C12.0221 4.3372 11.4564 3.77148 10.765 3.77148Z",
    fill: "#34657F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.e54f4ead0197e03b361498e153154b3d.svg";
export { ForwardRef as ReactComponent };